<template>
	<div class="element-wrapper text-left">
		<loading :active.sync="isLoading"></loading>

		<h6 class="element-header" v-if="headerShow">
			{{ t.bonus_transfer }}
		</h6>

		<div class="element-box-tp">
			<p>
			<div class="row">
				<div class="col-12">
					<div class="form-group">
						<label for="">{{ t.tranfer_to }}</label>
						<userAutoComplete :place="t.search_user" v-on:selected="selectTo" />
					</div>

					<div class="users-list-w">
						<div class="user-w with-status" :class="(selectedTo.online) ? 'status-green' : 'status-red'" v-if="selectedTo">
							<div class="user-avatar-w">
								<div class="user-avatar">
									<img alt="" :src="api+'api/v1/users/get/profile_pic/'+selectedTo.id"></div>
							</div>
							<div class="user-name">
								<h6 class="user-title">{{ selectedTo.name }}</h6>
								<div class="user-role">{{ selectedTo.username }}</div>
								<div class="user-role">{{ t.user.bonus }}: {{ selectedTo.bonus | toMoney( selectedTo.currency ) }}</div>
							</div>
							<a class="user-action" href="javascript:;">
								<div v-on:click="removeTo(null)" class="os-icon os-icon-cancel-circle"></div>
							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="row" v-if="getTo()">
				<div class="col-12" v-if="selectedTo">
					<div class="form-group">
						<label for="">{{ t.amount }}</label>
						<div class="input-group">
							<input class="form-control" v-model="amount" placeholder="Amount..." type="text" value="0.00">
							<div class="input-group-append">
								<div class="input-group-text">
									{{ selectedTo.currency.iso_code }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12" v-if="selectedTo">
					<div class="form-group">
						<label for="">Promotion</label>
						<div class="input-group pt-1">
							<select id="promos" class="form-control form-control-sm form-control-faded" v-model="promotion">
								<option v-for="option in promotions" v-bind:value="option.id">
									{{ option.title }}
								</option>
							</select>
						</div>
					</div>
				</div>
			</div>

			<div class="row" v-if="getTo()">
				<div class="col-6" v-if="transferType == 3">
					<button class="btn btn-danger btn-block btn-lg" v-on:click="selectOperate('-')">- <span>{{ t.withdraw_bonus }}</span></button>
				</div>
				<div class="col-6">
					<button class="btn btn-success btn-block btn-lg" v-on:click="selectOperate('+')">+ <span>{{ t.send_bonus }}</span></button>
				</div>
			</div>

			<div class="row">
				<div class="col-12 pt-4">
					<div class="alert alert-success" v-for="r in response">
						{{ r }}
					</div>
					<div class="alert alert-danger" v-for="error in errors">
						{{ error }}
					</div>
				</div>
			</div>
			</p>
		</div>
	</div>
</template>

<script>
    import Choices from 'choices.js'
    import userAutoComplete from '@/components/autocomplete/userAutoComplete'
    import DatePicker from 'vue2-datepicker'

    export default {
        name: 'bonusTransfer',
        components: { userAutoComplete, 'date-picker': DatePicker },
        props: {
            uid: {
                default: 0
            },
            headerShow: {
                default: 1
	        }
        },
        data () {
            return {
                api: window.api,
                t: this.$root.t,
                session: this.$root.session,
                transactionType: 3,
                transactionTypes: [
                    {name:  this.$root.t.transfer, val: 1},
                    {name:  this.$root.t.transfer_from_to, val: 2}
                ],
                transferType: 3,
                transferTypes: [
                    {name:  this.$root.t.cash, val: 1},
                    {name:  this.$root.t.credit, val: 2}
                ],
                selectedTo: null,
                selectedFrom: null,
                operate: '+',
                amount: 0,
                response: null,
                expiryDate: this.moment().add(5, 'days'),
                errors: null,
                isLoading: false,
                response: null,
                userId: 0,
	            promotion: null,
                promotions: null
            }
        },
        watch: {
            '$route.query._mt_id' (o, n) {
                this.userId = n;
                this.setTo(n);
            },
            'userId' (o, n) {
                this.setTo();
            },
            '$props.uid' (o, n) {
                this.setTo(o);
            }
        },
        mounted (){
            this.userId = this.uid;
            this.fetchPromotions();
        },
        methods: {
            transferNow () {
                this.transactionType = 2;
                this.transaction();
            },
            selectOperate (s) {
                this.transactionType = 1;
                this.operate = s;
                this.transaction();
            },
            selectTo (s) {
                if (this.getFrom() != s.id)
                {
                    this.selectedTo = s;
                }
            },
            selectFrom (s) {
                if (this.getTo() != s.id)
                {
                    this.selectedFrom = s;
                }
            },
            removeTo () {
                this.selectedTo = null;
            },
            removeFrom () {
                this.selectedFrom = null;
            },
            changeType (t) {
                this.transferType = 1;
                this.transactionType = t;
            },
            getTo() {
                return (this.selectedTo) ? this.selectedTo.id : 0
            },
            getFrom() {
                return (this.selectedFrom) ? this.selectedFrom.id : 0
            },
            setTo(id) {
                var id = (id) ? id : this.userId ;
                this.selectedTo = null;

                this.$http.get(api+'api/v1/user/'+id+'?noCache=1').then(response => {
                    // get body data
                    this.selectedTo = response.body.result;
                    this.promotion = (this.selectedTo.promotion) ? this.selectedTo.promotion.id : null;

	                setTimeout( () => {
	                    var element = window.document.getElementById('promos');

	                var example = new Choices(element, {
	                    removeItemButton: true,

	                });
	            }, 500)
            }, response => {

                })

            },
            fetchPromotions () {

                this.$http.get(api+'api/v1/promotions?noCache=1').then(response => {
                    // get body data
                    this.promotions = response.body.promotions;
                    this.promotion = (this.promotions) ? this.promotions[0].id : null;


                }, response => {
                })
            },
            setFrom(id) {
                var id = (id) ? id : this.$route.query._mt_id;
                this.$http.get(api+'api/v1/user/'+id).then(response => {
                    // get body data
                    this.selectedFrom = response.body.result;

            }, response => {

                })
            },
            transaction () {
                this.isLoading = true;
                this.$http.post(api+'api/v1/user/transaction/money_transfer',  {promotion: this.promotion,mode: this.transactionType, type: this.transferType, amount: this.amount, operate: this.operate,to: this.getTo(), from: this.getFrom(), expiryDate: this.moment(this.expiryDate).utc().format("YYYY-MM-DD HH:mm:ss")} ).then(response => {
                    // get body data
                    this.response = response.body.result;
                    this.errors = response.body.error;

                this.setTo(this.getTo());
                this.setFrom(this.getFrom());

                this.isLoading = false;

            }, response => {
                    this.errors = response.body.error;
                    this.isLoading = false;
                })

                setTimeout(() => {
                    this.errors = null;
                    this.response = null;
                },5000);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/bonusTransfer.vue